import axios from 'axios'
import { getToken } from '@/utils/auth'

export function success(res) {
    return Promise.resolve(res.data)
}

export function error(err) {
    if (err.message === 'Network Error') {
        return Promise.reject({
            message: 'Kết nối bị gián đoạn, vui lòng thử lại.',
        })
    } else if (err.response?.data) {
        return Promise.reject(err.response.data)
    }

    return Promise.reject('Đã xảy ra một lỗi bất ngờ chưa rõ nguyên nhân, vui lòng thử lại.')
}

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_URL,
    timeout: 60000,
    headers: {
        // 'X-Requested-With': 'XMLHttpRequest',
    },
})

service.interceptors.request.use(
    config => {
        let token = getToken()

        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }

        return config
    },
    error => {
        return Promise.reject(error)
    },
)

// response interceptor
service.interceptors.response.use(success, error)

export default service
